export default {
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}
